import HeroSection from '../../conduct-risk/HeroSection';
import { routesMap } from '../../../routes/AppRoutes';
import { Reports } from '../../../api/apiTypes';

interface DataFromParent {
  report: Reports | undefined;
}

const BannerListaDriverPage = ({ report }: DataFromParent) => {
  return (
    <HeroSection
      title={report?.name ?? ''}
      description={report?.description ?? 'Consulta e gestisci i driver di questo report.'}
      breadcrumbLinks={[
        { url: routesMap.HOME_PAGE, title: 'Home' },
        { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution' },
        { url: routesMap.REPORT_PAGE, title: 'Report' },
        { url: '#', title: report?.name ?? '' },
      ]}
    />
  );
};

export default BannerListaDriverPage;
